"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecordingCard = void 0;

var tslib_1 = require("tslib");
/* eslint-disable jsx-a11y/media-has-caption */


var ui_anchored_overlay_1 = require("@hopin-team/ui-anchored-overlay");

var ui_flex_1 = require("@hopin-team/ui-flex");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_inplace_editor_1 = require("@hopin-team/ui-inplace-editor");

var ui_menu_1 = require("@hopin-team/ui-menu");

var ui_pill_1 = require("@hopin-team/ui-pill");

var ui_spinner_1 = require("@hopin-team/ui-spinner");

var ui_toggle_1 = require("@hopin-team/ui-toggle");

var ui_tool_tip_1 = require("@hopin-team/ui-tool-tip");

var use_id_1 = require("@hopin-team/use-id");

var react_1 = tslib_1.__importStar(require("react"));

var build_timestamp_text_1 = require("./build-timestamp-text");

var root_1 = require("./styled/root");

var status_1 = require("./styled/status");
/* eslint-disable-next-line @typescript-eslint/no-empty-function */


var noop = function noop() {};

var TITLE_MAX_LINES = 2;

var RecordingCard = function RecordingCard(_a) {
  var _b, _c;

  var className = _a.className,
      __UIScope = _a.__UIScope,
      recording = _a.recording,
      _d = _a.maxTitleLength,
      maxTitleLength = _d === void 0 ? 25 : _d,
      maxLengthMessage = _a.maxLengthMessage,
      _e = _a.onClick,
      onClick = _e === void 0 ? noop : _e,
      onRecordingChange = _a.onRecordingChange,
      _f = _a.isShowingDetails,
      isShowingDetails = _f === void 0 ? true : _f,
      _g = _a.locale,
      locale = _g === void 0 ? 'en' : _g,
      thumbnailOverlayWrapper = _a.thumbnailOverlayWrapper,
      _h = _a.actionMenuTitle,
      actionMenuTitle = _h === void 0 ? 'Toggle action menu' : _h,
      playRecordingTitle = _a.playRecordingTitle,
      _j = _a.publishText,
      publishText = _j === void 0 ? 'Publish' : _j,
      _k = _a.publishedStatusText,
      publishedStatusText = _k === void 0 ? 'Published' : _k,
      _l = _a.processingStatusText,
      processingStatusText = _l === void 0 ? 'Processing' : _l,
      _m = _a.processingStatusDetailsText,
      processingStatusDetailsText = _m === void 0 ? 'Video is processing' : _m,
      _o = _a.publishToolTipText,
      publishToolTipText = _o === void 0 ? 'If Replay is enabled, attendees can view published recordings in the Replay tab.' : _o,
      recordingTrimmingFailedMessage = _a.recordingTrimmingFailedMessage,
      recordingTrimmingProcessingMessage = _a.recordingTrimmingProcessingMessage,
      eventPartTypeName = _a.eventPartTypeName,
      renderActionMenu = _a.renderActionMenu,
      _p = _a.isProcessing,
      isProcessing = _p === void 0 ? false : _p,
      _q = _a.isPublished,
      isPublished = _q === void 0 ? false : _q;
  var actionMenuButtonId = (0, use_id_1.useId)();

  var _r = tslib_1.__read((0, react_1.useState)(false), 2),
      isActionMenuShowing = _r[0],
      setIsActionMenuShowing = _r[1];

  var anchorRef = (0, react_1.useRef)(null);
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'RecordingCard',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var isDetailsFooterVisible = !isProcessing && (onRecordingChange || renderActionMenu);
  var isTitleEditable = !isProcessing && onRecordingChange;
  var id = recording.id,
      thumbnail = recording.thumbnail,
      startedAt = recording.startedAt,
      endedAt = recording.endedAt,
      recordingTitle = recording.title,
      createdAt = recording.createdAt,
      timestampAsText = recording.timestampAsText;
  var timestampText = (0, react_1.useMemo)(function () {
    return timestampAsText || (0, build_timestamp_text_1.buildRecordingSubtitle)({
      startedAt: startedAt,
      endedAt: endedAt,
      locale: locale
    });
  }, [timestampAsText, startedAt, endedAt, locale]);
  var ThumbnailOverlayWrapper = thumbnailOverlayWrapper || root_1.VideoOverlayWrapper;

  var _s = tslib_1.__read((0, react_1.useState)({
    current: (0, build_timestamp_text_1.buildRecordingTitle)({
      title: recordingTitle,
      createdAt: createdAt,
      startedAt: startedAt,
      locale: locale
    })
  }), 2),
      title = _s[0],
      setTitle = _s[1];

  (0, react_1.useEffect)(function () {
    setTitle({
      current: (0, build_timestamp_text_1.buildRecordingTitle)({
        title: recording.title,
        createdAt: createdAt,
        startedAt: startedAt,
        locale: locale
      })
    });
  }, [recording, setTitle, startedAt, createdAt, locale]);
  return react_1.default.createElement(root_1.Root, {
    className: rootClasses
  }, react_1.default.createElement(root_1.VideoContainer, null, isPublished && react_1.default.createElement(root_1.RecordingStatus, {
    label: publishedStatusText,
    pattern: "informational"
  }), isProcessing && react_1.default.createElement(root_1.RecordingStatus, {
    priority: "low",
    label: processingStatusText,
    pattern: "warning"
  }), thumbnail ? react_1.default.createElement(root_1.VideoThumbnail, {
    src: thumbnail,
    style: {
      borderRadius: isShowingDetails ? '8px 8px 0 0' : '8px'
    },
    "data-testid": "thumbnail-".concat(id),
    alt: recording.title
  }) : react_1.default.createElement(root_1.DefaultVideoThumbnail, {
    "data-testid": "recording card default thumbnail"
  }), ((_b = recording.lastEdit) === null || _b === void 0 ? void 0 : _b.status) === 'processing' ? react_1.default.createElement(status_1.IndeterminateProgressOverlay, {
    "aria-valuetext": recordingTrimmingProcessingMessage,
    rounded: !isShowingDetails
  }) : null, !isProcessing && react_1.default.createElement(ThumbnailOverlayWrapper, {
    recording: recording
  }, react_1.default.createElement(root_1.VideoOverlay, {
    onClick: onClick,
    "data-testid": "video-".concat(id, "-cta"),
    fullRounded: !isShowingDetails
  }, react_1.default.createElement(root_1.PlayButton, {
    icon: "play",
    title: playRecordingTitle,
    size: "medium",
    isRound: true
  }))), ((_c = recording.lastEdit) === null || _c === void 0 ? void 0 : _c.status) === 'failure' ? react_1.default.createElement(status_1.RecordingErrorMessage, {
    rounded: !isShowingDetails
  }, recordingTrimmingFailedMessage) : null), isShowingDetails && react_1.default.createElement(root_1.DetailsContainer, null, react_1.default.createElement(ui_flex_1.Flex, {
    flexDirection: "column"
  }, isTitleEditable ? react_1.default.createElement(ui_inplace_editor_1.InplaceEditor, {
    "data-testid": "recordingTitle",
    value: title,
    mb: 1,
    handleInputChange: function handleInputChange(newValue) {
      return onRecordingChange(id, {
        title: newValue
      });
    },
    maxLengthMessage: maxLengthMessage,
    maxCount: maxTitleLength,
    maxLines: TITLE_MAX_LINES
  }) : react_1.default.createElement(ui_inplace_editor_1.InplaceEditor, {
    value: title,
    mb: 1,
    readOnly: true,
    maxLines: TITLE_MAX_LINES
  }), react_1.default.createElement(root_1.TileSubtitleText, {
    "data-testid": "recordingSubtitle",
    element: "p"
  }, timestampText)), react_1.default.createElement(ui_flex_1.Flex, null, !isProcessing && react_1.default.createElement(ui_pill_1.Pill, {
    label: eventPartTypeName,
    p: 1
  }))), isProcessing && react_1.default.createElement(ui_flex_1.Flex, {
    p: 2,
    mt: "auto",
    alignItems: "flex-end"
  }, react_1.default.createElement(ui_spinner_1.Spinner, {
    "data-testid": "recording card processing spinner",
    pattern: "secondary",
    isShowing: true
  }), react_1.default.createElement(root_1.ProcessingStatusDetails, {
    ml: 1
  }, processingStatusDetailsText)), isDetailsFooterVisible && react_1.default.createElement(root_1.DetailsFooterContainer, null, onRecordingChange && react_1.default.createElement(ui_flex_1.Flex, {
    flexGrow: 1
  }, react_1.default.createElement(ui_tool_tip_1.ToolTip, {
    tip: publishToolTipText
  }, react_1.default.createElement(ui_toggle_1.Toggle, {
    label: publishText,
    onChange: function onChange() {
      return onRecordingChange(id, {
        published: !isPublished
      });
    },
    isToggled: isPublished
  }))), renderActionMenu ? react_1.default.createElement(ui_flex_1.Flex, {
    justifyContent: "flex-end",
    flexGrow: 1
  }, react_1.default.createElement(ui_flex_1.Flex, null, react_1.default.createElement(root_1.ActionMenuButton, {
    id: actionMenuButtonId,
    "data-testid": "action-menu-button-".concat(id),
    onClick: function onClick() {
      return setIsActionMenuShowing(!isActionMenuShowing);
    },
    icon: "option",
    size: "small",
    isRound: true,
    isOutlined: true,
    title: actionMenuTitle,
    ref: anchorRef
  })), isActionMenuShowing && react_1.default.createElement(ui_anchored_overlay_1.AnchoredOverlay, {
    anchorRef: anchorRef,
    onDismiss: function onDismiss() {
      return setIsActionMenuShowing(false);
    },
    "aria-labelledby": actionMenuButtonId,
    overlayAlignment: "right"
  }, react_1.default.createElement(ui_menu_1.Menu, {
    isShowing: true,
    mt: 1
  }, react_1.default.createElement(ui_menu_1.MenuContent, {
    p: 1
  }, react_1.default.createElement(ui_menu_1.MenuSelect, {
    labelledById: actionMenuButtonId,
    currentIndex: -1
  }, renderActionMenu(function () {
    return setIsActionMenuShowing(false);
  })))))) : null));
};

var RecordingCardWithSpace = (0, ui_helper_with_space_1.withSpace)(RecordingCard);
exports.RecordingCard = RecordingCardWithSpace;